import { translate } from "app/filters/i18nFilter";
import { cpcFilter, abbrNumberFilter } from "app/filters/ngFilters";

import { getShareValue, getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";

import { adTypeColumnIconConfig } from "app/common/keyword-research/website-search-ads/searchAdsTableConsts";
import type {
    IData,
    IDataRecord,
    ITransformDataObject,
} from "app/common/keyword-research/website-search-ads/searchAdsTableTypes";

export const transformData = (response: IDataRecord): ITransformDataObject => {
    const transformedData = response.Data.map((record: IData, index: number) => {
        if (!record.SerpType) {
            return;
        }
        const {
            Clicks,
            ClicksShare,
            SerpType,
            LandingPage,
            TopKeyword,
            Volume,
            AvgCpc,
            KeywordsCount,
            DestUrl,
            Image,
            TopLatestPos,
            ClicksChange,
            Domain,
            Favicon,
            AdId,
            ...rest
        } = record;
        const { iconName, tooltip } = adTypeColumnIconConfig[SerpType];
        const totalClicks = getVolumeValue(Clicks);
        return {
            key: index + 1,
            clicksShare: { totalClicks, value: getShareValue(ClicksShare) },
            adDetails: {
                value: { ...rest, ImageUrl: Image, DisplayUrl: DestUrl, AdType: SerpType, DestUrl: LandingPage },
            },
            adType: { iconDetails: { iconName, tooltip: translate(tooltip) } },
            clicksChange: ClicksChange,
            volume: abbrNumberFilter()(Volume),
            avgCpc: cpcFilter()(AvgCpc, 2),
            keywordsCount: KeywordsCount, // enriched row
            topKeyword: TopKeyword,
            landingPage: LandingPage,
            position: { position: [{ Value: TopLatestPos }] },
            domain: {
                value: Domain,
                favicon: Favicon,
            },
            adId: AdId,
        };
    }).filter(Boolean);
    return { data: transformedData, totalCount: response.TotalCount };
};
